import Notification from './Notification'
export default Notification



// WEBPACK FOOTER //
// ./components/vc-notification/index.js